<script lang="ts">
    import { _ } from "svelte-i18n"
    import { getCountry } from "../../api"
    import { formatPriceCurrency, langField } from "../../i18n"
    import { checkoutData, getAsyncCartSum, login, setCartItemQuantity } from "../../store"
    import { firstProductImage } from "../../utils"

    export let cartItems: CartItem[]

    let cartSum: CartSum
    $: (async () => {
        cartSum = await getAsyncCartSum(cartItems)
    })()
</script>

<div class="list">
    {#each cartItems as cartItem, idx}
        <div class="product" class:invalid="{$login && cartItem.product.no_dealers}">
            <div class="image">
                <a style="height: 100%" href="/product/{cartItem.product.code}_{langField(cartItem.product.slug, '')}">
                    <img
                        src="{firstProductImage(cartItem.product, 's')}"
                        alt="{langField(cartItem.product.name, '')}"
                    />
                </a>
                <!-- <div class="num">{cartItem.quantity}</div> -->
            </div>
            <div class="text">
                <div class="title">
                    {langField(cartItem.product?.name, "")}
                </div>
                <div class="artnum">
                    {$_("cart.item-number-short")}
                    {cartItem.product?.code}
                </div>
                {#if cartItem.user_inputs && Object.keys(cartItem.user_inputs).length}
                    <div class="variant">
                        {#if cartItem.user_inputs?.engraving_line_1}
                            <b>{$_("cart.engraving-line-1")}:</b>
                            {cartItem.user_inputs.engraving_line_1}<br />
                        {/if}
                        {#if cartItem.user_inputs?.engraving_line_2}
                            <b>{$_("cart.engraving-line-2")}:</b>
                            {cartItem.user_inputs.engraving_line_2}<br />
                        {/if}
                        {#if cartItem.user_inputs?.engraving_line_3}
                            <b>{$_("cart.engraving-line-3")}:</b>
                            {cartItem.user_inputs.engraving_line_3}<br />
                        {/if}
                        {#if cartItem.user_inputs?.key_number}
                            <b>{$_("cart.key-number")}:</b>
                            {#if cartItem.user_inputs.key_number == -1}
                                {$_("cart.whatever")}
                            {:else}
                                {cartItem.user_inputs.key_number}
                            {/if}
                            <br />
                        {/if}
                    </div>
                {/if}
                <div class="buttons">
                    <div class="counter">
                        <button
                            class="btn btn-transparent"
                            type="button"
                            on:click="{() => {
                                setCartItemQuantity(cartItem, cartItem.quantity - 1)
                            }}">-</button
                        >
                        <span class="nr">{cartItem.quantity}</span>
                        <button
                            class="btn btn-transparent"
                            type="button"
                            on:click="{() => {
                                setCartItemQuantity(cartItem, cartItem.quantity + 1)
                            }}">+</button
                        >
                    </div>
                    <button
                        type="button"
                        class="btn btn-secondary"
                        on:click="{() => {
                            setCartItemQuantity(cartItem, 0)
                        }}">{$_("cart.remove")}</button
                    >
                </div>
            </div>
            <div class="price">
                {$formatPriceCurrency(cartItem.price.unit, $login ? 0 : $checkoutData.vat, cartItem.quantity)}
            </div>
        </div>
    {/each}
</div>
{#if cartSum}
    <div class="result">
        <section>
            <div class="sum1">
                <div class="title">{$_("cart.subtotal")}</div>
                <div class="value">
                    {$formatPriceCurrency(cartSum.subtotalGross)}
                </div>
            </div>
        </section>
        {#if cartSum.minQtyGross}
            <section>
                <div class="shipping">
                    <div class="title">
                        <!--Mindermengenzuschlag-->{$_("cart.shipping-costs")}
                        <div class="small">
                            {$_("cart.less-30eur-order-value")}
                        </div>
                    </div>
                    <div class="value">
                        {$formatPriceCurrency(cartSum.minQtyGross)}
                    </div>
                </div>
            </section>
        {/if}
        {#if cartSum.packagingGross}
            <section>
                <div class="shipping">
                    <div class="title">
                        {$_("cart.packaging")}
                    </div>
                    <div class="value">
                        {$formatPriceCurrency(cartSum.packagingGross)}
                    </div>
                </div>
            </section>
        {/if}
        {#if cartSum.shippingGross}
            <section>
                <div class="shipping">
                    <div class="title">
                        {$_("cart.shipping")}
                        {#if !$login}
                            {#await getCountry($checkoutData.deliveryAddress.countryCode) then country}
                                <div class="small">
                                    {langField(country.name, "")}
                                </div>
                            {/await}
                        {/if}
                    </div>
                    <div class="value">
                        {$formatPriceCurrency(cartSum.shippingGross)}
                    </div>
                </div>
            </section>
        {/if}
        <section>
            <div class="sum2">
                <div class="title">
                    {$_("cart.total")}
                    <div class="small">
                        {#if $login}
                            {$_("cart.without-vat-short")}
                        {:else}
                            {$_("cart.with-percent-vat-short", {
                                values: { percent: $checkoutData.vat },
                            })}
                        {/if}
                    </div>
                </div>
                <div class="value">
                    {$formatPriceCurrency(cartSum.totalGross)}
                </div>
            </div>
        </section>
    </div>
{/if}
